function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { schema } from '../schema.js';
export function defaults(schema) {
  var _a;

  let result = {};
  let props = (_a = schema.properties) !== null && _a !== void 0 ? _a : {};
  Object.keys(props).forEach(key => {
    let val = props[key];

    if (typeof val === 'object' && undefined !== val.default) {
      if (Array.isArray(val.default)) {
        result[key] = [...val.default];
      } else if (typeof val.default === 'object') {
        result[key] = _objectSpread({}, val.default);
      } else {
        result[key] = val.default;
      }
    }
  });
  return result;
}
export function merge(style, options) {
  var _a;

  let result = _objectSpread(_objectSpread(_objectSpread({}, defaults(schema)), defaults((_a = style.schema) !== null && _a !== void 0 ? _a : {})), options); // Return a complete copy because the styles could partially customize the
  // options and thus modify nested objects and arrays.


  return JSON.parse(JSON.stringify(result));
}